import * as $ from 'jquery';
import 'datepicker';
import 'selectize';
import 'moment';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { headerContent } from "./c002";
import { wcagOptions } from "./wcag";

export class bookingFormSideTrip {
    private bcommon = new bookingFormCommon();
    private wcag = new wcagOptions();
    private bookingFormSubmit = new bookingFormSubmit();
    isUkCitySelectedForIbeSearch: boolean = false;
    $officeCode: string = '';
    /**
	 * @function init
	 * !!! Global
	 */
    init(instance: any): void {
        let curInstance = $(instance);
        let $passengerDetails: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details]');
        let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');
        $passengerDetailsActive.hide();
        $passengerDetails.addClass('passenger-focused');
        $passengerDetails.show();
        $passengerDetails.find('.total-passengers-oneway').show();
        let $passengerReturnDetails: any = curInstance.find('[data-sidetrip-return-booking-passenger-details]');
        let $passengerReturnDetailsActive: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');
        $passengerReturnDetailsActive.hide();
        $passengerReturnDetails.addClass('passenger-focused');
        $passengerReturnDetails.show();
        $passengerReturnDetails.find('.total-passengers-return').show();
        let $passengerDetailsSideTrip: any = curInstance.find('[data-sidetrip-booking-passenger-details]');
        let $passengerDetailsActiveSideTrip: any = curInstance.find('[data-sidetrip-booking-passenger-details-selected]');
       $passengerDetailsActiveSideTrip.hide();
        $passengerDetailsSideTrip.addClass('passenger-focused');
        $passengerDetailsSideTrip.show();
        $passengerDetailsSideTrip.find('.total-passengers-sidetrip').show();
    }
    /**
	 * @function passengerTypeOneWay
	 * !!! Properly scoped
	 */
    // passengerTypeOneWay(instance: any): void {
    //     let curInstance = $(instance);

    //     let $bookDateSelector = curInstance.find('.book-date--selector');
    //     let $passengerDetails: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details]');
    //     let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');

    //     let $cabinClass = curInstance.find('.cabinClass');
    //     let $psngTitleCaption = $passengerDetailsActive.find('.title-caption');
    //     let $psngTotalPassengers = $passengerDetailsActive.find('.total-passengers-oneway');


    //     $(document).on('click', function () {
    //         $passengerDetailsActive.hide();
    //     });

    //     $passengerDetails.click(function (e: any) {
    //         $passengerDetailsActive.show();
    //         e.stopPropagation();
    //         $bookDateSelector.removeClass('datepicker-selected');
    //     });

    //     $passengerDetailsActive.on('mouseleave', function () {
    //         // $(this).hide();
    //     }).find('button, input').on('click', function (evt: any) {
    //         evt.stopPropagation();
    //     });

    //     let $psngEls = [$psngTitleCaption, $psngTotalPassengers, $cabinClass];

    //     $.each($psngEls, function (index: number, el: any) {
    //         el.click(function () {
    //             $passengerDetailsActive.hide();
    //             $passengerDetails.addClass('passenger-focused');
    //             $passengerDetails.show();
    //             $passengerDetails.find('.total-passengers-oneway').show();
    //             $bookDateSelector.removeClass('datepicker-selected');
    //         });
    //     });
    // }
    // /**
    // * @function passengerTypeReturn
    // * !!! Properly scoped
    // */
    // passengerTypeReturn(instance: any): void {
    //     let curInstance = $(instance);

    //     let $bookDateSelector = curInstance.find('.book-date--selector');
    //     let $passengerDetails: any = curInstance.find('[data-sidetrip-return-booking-passenger-details]');
    //     let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-return-booking-passenger-details-selected]');

    //     let $cabinClass = curInstance.find('.cabinClass');
    //     let $psngTitleCaption = $passengerDetailsActive.find('.title-caption');
    //     let $psngTotalPassengers = $passengerDetailsActive.find('.total-passengers-return');


    //     $(document).on('click', function () {
    //         $passengerDetailsActive.hide();
    //     });

    //     $passengerDetails.click(function (e: any) {
    //         $passengerDetailsActive.show();
    //         e.stopPropagation();
    //         $bookDateSelector.removeClass('datepicker-selected');
    //     });

    //     $passengerDetailsActive.on('mouseleave', function () {
    //         // $(this).hide();
    //     }).find('button, input').on('click', function (evt: any) {
    //         evt.stopPropagation();
    //     });

    //     let $psngEls = [$psngTitleCaption, $psngTotalPassengers, $cabinClass];

    //     $.each($psngEls, function (index: number, el: any) {
    //         el.click(function () {
    //             $passengerDetailsActive.hide();
    //             $passengerDetails.addClass('passenger-focused');
    //             $passengerDetails.show();
    //             $passengerDetails.find('.total-passengers-return').show();
    //             $bookDateSelector.removeClass('datepicker-selected');
    //         });
    //     });
    // }

    /**
	 * @function passengerTypeSideTrip
	 * !!! Properly scoped
	 */
    passengerTypeSideTrip(instance: any): void {
        let curInstance = $(instance);

        let $bookDateSelector = curInstance.find('.book-date--selector');
        let $passengerDetails: any = curInstance.find('[data-sidetrip-booking-passenger-details]');
        let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-booking-passenger-details-selected]');

        let $cabinClass = curInstance.find('.cabinClass');
        let $psngTitleCaption = $passengerDetailsActive.find('.title-caption');
        let $psngTotalPassengers = $passengerDetailsActive.find('.total-passengers-sidetrip');


        $(document).on('click', function () {
          $passengerDetailsActive.hide();
        });

        $passengerDetails.click(function (e: any) {
            $passengerDetailsActive.show();
            e.stopPropagation();
            $bookDateSelector.removeClass('datepicker-selected');
        });

        $passengerDetailsActive.on('mouseleave', function () {
            // $(this).hide();
        }).find('button, input').on('click', function (evt: any) {
            evt.stopPropagation();
        });

        let $psngEls = [$psngTitleCaption, $psngTotalPassengers, $cabinClass];

        $.each($psngEls, function (index: number, el: any) {
            el.click(function () {
                $passengerDetailsActive.hide();
                $passengerDetails.addClass('passenger-focused');
                $passengerDetails.show();
                $passengerDetails.find('.total-passengers-sidetrip').show();
                $bookDateSelector.removeClass('datepicker-selected');
            });
        });
    }
    /**
	 * @function passengerDetailsOneWay
	 * !!! Properly scoped
	 */
    // passengerDetailsOneWay(instance: any): void {
    //     let curInstance = $(instance).find('#sidetrip-oneway-details-expanded'); // assign current instance to var as later requests will call latest assigned instance		
    //     let $ticketAdultInput: number = 1;
    //     //let $ticketYouthInput:number = 0;
    //     let $ticketChildInput: number = 0;
    //     let $ticketInfantInput: number = 0;
    //     let $totalTickets: number = 1;
    //     let $ticketTeenagerInput: number = 0;
    //     let $totalPassenger: any = curInstance.find('.total-passengers-oneway');

    //     let $groupBooking = curInstance.find('.group-booking-oneway');

    //     $totalPassenger.find('.total-nos-oneway').html($totalTickets);
    //     curInstance.find('input.total-tickets-oneway--value').val($totalTickets);

    //     curInstance.find('.mobile-ticketnos-sidetrip--btn').on('click', function (e: any) {
    //         e.preventDefault();
    //         let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');

    //         // declare passenger input variables
    //         // scope them to prevent multiple elements from being retrieved
    //         // (deals component uses the same class name for its inputs)
    //         let $adultInput = $passengerDetailsActive.find('.ticket-mob-adult--input');
    //         let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
    //         let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
    //         // let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

    //         let $adultBookingErr = curInstance.find('.adult-booking--error---sidetrip');
    //         let $infantBookingErr = curInstance.find('.infant-booking--error---sidetrip');


    //         // get currently acted on input field
    //         var fieldName = $(this).attr('data-field'),
    //             type = $(this).attr('data-type'),
    //             input = curInstance.find("input[name='" + fieldName + "']"),
    //             currentVal = parseInt(input.val());

    //         // apply calculation to acted-on field (plus/minus)
    //         if (!isNaN(currentVal)) {
    //             input.data('oldValue', currentVal);
    //             if (type == 'minus') {
    //                 if (currentVal > parseInt(input.attr('min'))) {
    //                     input.val(currentVal - 1);
    //                     input.trigger('change');
    //                 }
    //                 if (parseInt(input.val()) == parseInt(input.attr('min'))) {
    //                     $(this).attr('disabled', true);
    //                 }
    //             } else if (type == 'plus') {
    //                 if (currentVal < input.attr('max')) {
    //                     input.val(currentVal + 1);
    //                     input.trigger('change');
    //                 }
    //                 if (parseInt(input.val()) == input.attr('max')) {
    //                     $(this).attr('disabled', true);
    //                 }
    //             }
    //         } else {
    //             input.val(0);
    //         }

    //         // check if infants added exceeds adults added and display error if met
    //         let $adultInputVal: number = parseInt($adultInput.val());
    //         let $infantInputVal: number = parseInt($infantInput.val());

    //         // test if infants added > adults added
    //         // display error message if true
    //         // only show error below infant item
    //         if ($infantInputVal > $adultInputVal) {
    //             $infantBookingErr.show();
    //             // $adultBookingErr.show();
    //         } else {
    //             $infantBookingErr.hide();
    //             // $adultBookingErr.hide();
    //         }
    //     });

    //     // disable user input on field (next statement will no longer have any effect)
    //     curInstance.find('.minus-plus-input-sidetrip').attr('readonly', true);
    //     // store current value of input to data-attribute on focus
    //     // in case user manually edits fields
    //     curInstance.find('.minus-plus-input-sidetrip').focusin(function () {
    //         $(this).data('oldValue', $(this).val());
    //     });

    //     // on value increment/decrement, update old value data-attribute
    //     curInstance.find('.minus-plus-input-sidetrip').on('change', function () {
    //         let minValue = parseInt($(this).attr('min'));
    //         let maxValue = parseInt($(this).attr('max'));
    //         let valueCurrent = parseInt($(this).val());
    //         let name = $(this).attr('name');
    //         if (valueCurrent >= minValue) {
    //             curInstance.find(".mobile-ticketnos-sidetrip--btn[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
    //         } else {
    //             $(this).data('oldValue', $(this).val());
    //         }
    //         if (valueCurrent <= maxValue) {
    //             curInstance.find(".mobile-ticketnos-sidetrip--btn[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    //         } else {
    //             $(this).data('oldValue', $(this).val());
    //         }
    //         updateTicketQtysOneWay();
    //     });

    //     // prevent input to passenger number field by keyboard
    //     // only allow change from pressing buttons
    //     curInstance.find('.minus-plus-input-sidetrip').keydown(function (e: any) {
    //         if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
    //             (e.keyCode == 65 && e.ctrlKey === true) ||
    //             (e.keyCode >= 35 && e.keyCode <= 39)) {
    //             return;
    //         }
    //         if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    //             e.preventDefault();
    //         }
    //     });
    //     // run once on ready
    //     // _self.$instance.find('.minus-plus-input-sidetrip').trigger('change');
    //     updateTicketQtysOneWay();

    // 	/**
    // 	 * calculate total ticket amount based on current values and populate display fields
    // 	 * @return void
    // 	 */
    //     function updateTicketQtysOneWay() {
    //         let $passengerDetailsActive = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');
    //         $ticketTeenagerInput = parseInt($passengerDetailsActive.find('.ticket-mob-teenager--input').val());
    //         // get current values in input field and assign to method vars
    //         $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
    //         $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
    //         $ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-mob-infant--input').val());

    //         // only adult and child tickets count towards limit
    //         $totalTickets = $ticketAdultInput + $ticketTeenagerInput + $ticketChildInput;
    //         let $totalPassengersVal: any = $totalTickets + $ticketInfantInput;
    //         let $totalPassenger: any = curInstance.find('.total-passengers-oneway');

    //         // update hidden input value for total tickets added
    //         // update display text for total tickets added
    //         curInstance.find('.total-tickets-oneway--value').val($totalTickets);
    //         $totalPassenger.find('.total-nos-oneway').html($totalPassengersVal);

    //         if ($totalTickets >= 2) {
    //             $totalPassenger.find('.type-oneway').html('Passengers');
    //         } else {
    //             $totalPassenger.find('.type-oneway').html('Passenger');
    //         }

    //         if ($totalTickets >= 9) {
    //             $groupBooking.hide();
    //             curInstance.find('.adult-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             curInstance.find('.child-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             curInstance.find('.teenager-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             // curInstance.find('.infant-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //         } else {
    //             $groupBooking.hide();
    //             curInstance.find('.adult-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             curInstance.find('.child-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             curInstance.find('.teenager-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             // curInstance.find('.infant-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //         }
    //     }
    // }
    // /**
    //  * @function passengerDetailsReturn
    //  * !!! Properly scoped
    //  */
    // passengerDetailsReturn(instance: any): void {
    //     let curInstance = $(instance).find('#sidetrip-return-details-expanded'); // assign current instance to var as later requests will call latest assigned instance		
    //     let $ticketAdultInput: number = 1;
    //     //let $ticketYouthInput:number = 0;
    //     let $ticketChildInput: number = 0;
    //     let $ticketInfantInput: number = 0;
    //     let $totalTickets: number = 1;
    //     let $ticketTeenagerInput: number = 0;
    //     let $totalPassenger: any = curInstance.find('.total-passengers-return');

    //     let $groupBooking = curInstance.find('.group-booking-return');

    //     $totalPassenger.find('.total-nos-return').html($totalTickets);
    //     curInstance.find('input.total-tickets-return--value').val($totalTickets);

    //     curInstance.find('.mobile-ticketnos-sidetrip--btn').on('click', function (e: any) {
    //         e.preventDefault();
    //         let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-return-booking-passenger-details-selected]');

    //         // declare passenger input variables
    //         // scope them to prevent multiple elements from being retrieved
    //         // (deals component uses the same class name for its inputs)
    //         let $adultInput = $passengerDetailsActive.find('.ticket-mob-adult--input');
    //         let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
    //         let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
    //         // let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

    //         let $adultBookingErr = curInstance.find('.adult-booking--error---sidetrip');
    //         let $infantBookingErr = curInstance.find('.infant-booking--error---sidetrip');


    //         // get currently acted on input field
    //         var fieldName = $(this).attr('data-field'),
    //             type = $(this).attr('data-type'),
    //             input = curInstance.find("input[name='" + fieldName + "']"),
    //             currentVal = parseInt(input.val());

    //         // apply calculation to acted-on field (plus/minus)
    //         if (!isNaN(currentVal)) {
    //             input.data('oldValue', currentVal);
    //             if (type == 'minus') {
    //                 if (currentVal > parseInt(input.attr('min'))) {
    //                     input.val(currentVal - 1);
    //                     input.trigger('change');
    //                 }
    //                 if (parseInt(input.val()) == parseInt(input.attr('min'))) {
    //                     $(this).attr('disabled', true);
    //                 }
    //             } else if (type == 'plus') {
    //                 if (currentVal < input.attr('max')) {
    //                     input.val(currentVal + 1);
    //                     input.trigger('change');
    //                 }
    //                 if (parseInt(input.val()) == input.attr('max')) {
    //                     $(this).attr('disabled', true);
    //                 }
    //             }
    //         } else {
    //             input.val(0);
    //         }

    //         // check if infants added exceeds adults added and display error if met
    //         let $adultInputVal: number = parseInt($adultInput.val());
    //         let $infantInputVal: number = parseInt($infantInput.val());

    //         // test if infants added > adults added
    //         // display error message if true
    //         // only show error below infant item
    //         if ($infantInputVal > $adultInputVal) {
    //             $infantBookingErr.show();
    //             // $adultBookingErr.show();
    //         } else {
    //             $infantBookingErr.hide();
    //             // $adultBookingErr.hide();
    //         }
    //     });

    //     // disable user input on field (next statement will no longer have any effect)
    //     curInstance.find('.minus-plus-input-sidetrip').attr('readonly', true);
    //     // store current value of input to data-attribute on focus
    //     // in case user manually edits fields
    //     curInstance.find('.minus-plus-input-sidetrip').focusin(function () {
    //         $(this).data('oldValue', $(this).val());
    //     });

    //     // on value increment/decrement, update old value data-attribute
    //     curInstance.find('.minus-plus-input-sidetrip').on('change', function () {
    //         let minValue = parseInt($(this).attr('min'));
    //         let maxValue = parseInt($(this).attr('max'));
    //         let valueCurrent = parseInt($(this).val());
    //         let name = $(this).attr('name');
    //         if (valueCurrent >= minValue) {
    //             curInstance.find(".mobile-ticketnos-sidetrip--btn[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
    //         } else {
    //             $(this).data('oldValue', $(this).val());
    //         }
    //         if (valueCurrent <= maxValue) {
    //             curInstance.find(".mobile-ticketnos-sidetrip--btn[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    //         } else {
    //             $(this).data('oldValue', $(this).val());
    //         }
    //         updateTicketQtysReturn();
    //     });

    //     // prevent input to passenger number field by keyboard
    //     // only allow change from pressing buttons
    //     curInstance.find('.minus-plus-input-sidetrip').keydown(function (e: any) {
    //         if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
    //             (e.keyCode == 65 && e.ctrlKey === true) ||
    //             (e.keyCode >= 35 && e.keyCode <= 39)) {
    //             return;
    //         }
    //         if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    //             e.preventDefault();
    //         }
    //     });
    //     // run once on ready
    //     // _self.$instance.find('.minus-plus-input-sidetrip').trigger('change');
    //     updateTicketQtysReturn();

    // 	/**
    // 	 * calculate total ticket amount based on current values and populate display fields
    // 	 * @return void
    // 	 */
    //     function updateTicketQtysReturn() {
    //         let $passengerDetailsActive = curInstance.find('[data-sidetrip-return-booking-passenger-details-selected]');
    //         $ticketTeenagerInput = parseInt($passengerDetailsActive.find('.ticket-mob-teenager--input').val());
    //         // get current values in input field and assign to method vars
    //         $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
    //         $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
    //         $ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-mob-infant--input').val());

    //         // only adult and child tickets count towards limit
    //         $totalTickets = $ticketAdultInput + $ticketTeenagerInput + $ticketChildInput;
    //         let $totalPassengersVal: any = $totalTickets + $ticketInfantInput;
    //         let $totalPassenger: any = curInstance.find('.total-passengers-return');

    //         // update hidden input value for total tickets added
    //         // update display text for total tickets added
    //         curInstance.find('.total-tickets-return--value').val($totalTickets);
    //         $totalPassenger.find('.total-nos-return').html($totalPassengersVal);

    //         if ($totalTickets >= 2) {
    //             $totalPassenger.find('.type-return').html('Passengers');
    //         } else {
    //             $totalPassenger.find('.type-return').html('Passenger');
    //         }

    //         if ($totalTickets >= 9) {
    //             $groupBooking.hide();
    //             curInstance.find('.adult-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             curInstance.find('.child-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             curInstance.find('.teenager-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //             // curInstance.find('.infant-nos .input-group-sidetrip--btn .plus').attr('disabled', true);
    //         } else {
    //             $groupBooking.hide();
    //             curInstance.find('.adult-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             curInstance.find('.child-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             curInstance.find('.teenager-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //             // curInstance.find('.infant-nos .input-group-sidetrip--btn .plus').attr('disabled', false);
    //         }
    //     }
    // }

    /**
    * @function passengerDetailsSideTrip
    * !!! Properly scoped
    */
    passengerDetailsSideTrip(instance: any): void {
        let curInstance = $(instance); // assign current instance to var as later requests will call latest assigned instance		
        let $ticketAdultInput: number = 1;
        //let $ticketYouthInput:number = 0;
        let $ticketChildInput: number = 0;
        let $ticketInfantInput: number = 0;
        let $totalTickets: number = 1;
        let $ticketTeenagerInput: number = 0;
        let $totalPassenger: any = curInstance.find('.total-passengers-sidetrip');
        let $groupBooking = curInstance.find('.group-booking-sidetrip');
        $totalPassenger.find('.total-nos-sidetrip').html($totalTickets);
        curInstance.find('input.total-tickets-sidetrip--value').val($totalTickets);
        curInstance.find('.mobile-ticketnos-bookst--btn').on('click', function (e: any) {
            e.preventDefault();
            let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-booking-passenger-details-selected]');
            // declare passenger input variables
            // scope them to prevent multiple elements from being retrieved
            // (deals component uses the same class name for its inputs)
            let $adultInput = $passengerDetailsActive.find('.ticket-mob-adult--input');
            let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
            let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
            // let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

            let $adultBookingErr = curInstance.find('.adult-booking--error---stbooking');
            let $infantBookingErr = curInstance.find('.infant-booking--error---stbooking');


            // get currently acted on input field
            var fieldName = $(this).attr('data-field'),
                type = $(this).attr('data-type'),
                input = curInstance.find("input[name='" + fieldName + "']"),
                currentVal = parseInt(input.val());

            // apply calculation to acted-on field (plus/minus)
            if (!isNaN(currentVal)) {
                input.data('oldValue', currentVal);
                if (type == 'minus') {
                    if (currentVal > parseInt(input.attr('min'))) {
                        input.val(currentVal - 1);
                        input.trigger('change');
                    }
                    if (parseInt(input.val()) == parseInt(input.attr('min'))) {
                        $(this).attr('disabled', true);
                    }
                } else if (type == 'plus') {
                    if (currentVal < input.attr('max')) {
                        input.val(currentVal + 1);
                        input.trigger('change');
                    }
                    if (parseInt(input.val()) == input.attr('max')) {
                        $(this).attr('disabled', true);
                    }
                }
            } else {
                input.val(0);
            }

            // check if infants added exceeds adults added and display error if met
            let $adultInputVal: number = parseInt($adultInput.val());
            let $infantInputVal: number = parseInt($infantInput.val());

            // test if infants added > adults added
            // display error message if true
            // only show error below infant item
            if ($infantInputVal > $adultInputVal) {
                $infantBookingErr.show();
                // $adultBookingErr.show();
            } else {
                $infantBookingErr.hide();
                // $adultBookingErr.hide();
            }
        });

        // disable user input on field (next statement will no longer have any effect)
        curInstance.find('.minus-plus-input-bookst').attr('readonly', true);
        // store current value of input to data-attribute on focus
        // in case user manually edits fields
        curInstance.find('.minus-plus-input-bookst').focusin(function () {
            $(this).data('oldValue', $(this).val());
        });

        // on value increment/decrement, update old value data-attribute
        curInstance.find('.minus-plus-input-bookst').on('change', function () {
            let minValue = parseInt($(this).attr('min'));
            let maxValue = parseInt($(this).attr('max'));
            let valueCurrent = parseInt($(this).val());
            let name = $(this).attr('name');
            if (valueCurrent >= minValue) {
                curInstance.find(".mobile-ticketnos-bookst--btn[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                $(this).data('oldValue', $(this).val());
            }
            if (valueCurrent <= maxValue) {
                curInstance.find(".mobile-ticketnos-bookst--btn[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                $(this).data('oldValue', $(this).val());
            }
            updateTicketQtysSideTrip();
        });

        // prevent input to passenger number field by keyboard
        // only allow change from pressing buttons
        curInstance.find('.minus-plus-input-bookst').keydown(function (e: any) {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                (e.keyCode == 65 && e.ctrlKey === true) ||
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                return;
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
        // run once on ready
        // _self.$instance.find('.minus-plus-input-sidetrip').trigger('change');
        updateTicketQtysSideTrip();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
        function updateTicketQtysSideTrip() {
            let $passengerDetailsActive = curInstance.find('[data-sidetrip-booking-passenger-details-selected]');
            $ticketTeenagerInput = parseInt($passengerDetailsActive.find('.ticket-mob-teenager--input').val());
            // get current values in input field and assign to method vars
            $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
            $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
            $ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-mob-infant--input').val());

            // only adult and child tickets count towards limit
            $totalTickets = $ticketAdultInput + $ticketTeenagerInput + $ticketChildInput;
            let $totalPassengersVal: any = $totalTickets + $ticketInfantInput;
            let $totalPassenger: any = curInstance.find('.total-passengers-sidetrip');

            // update hidden input value for total tickets added
            // update display text for total tickets added
            curInstance.find('.total-tickets-sidetrip--value').val($totalTickets);
            $totalPassenger.find('.total-nos-sidetrip').html($totalPassengersVal);
            if ($totalTickets >= 2) {
                $totalPassenger.find('.type-sidetrip').html('Passengers');
            } else {
                $totalPassenger.find('.type-sidetrip').html('Passenger');
            }

            if ($totalTickets >= 9) {
                curInstance.find('.adult-nos .input-group-bookst--btn .plus').attr('disabled', true);
                curInstance.find('.child-nos .input-group-bookst--btn .plus').attr('disabled', true);
                curInstance.find('.teenager-nos .input-group-bookst--btn .plus').attr('disabled', true);
                // curInstance.find('.infant-nos .input-group-bookst--btn .plus').attr('disabled', true);
            } else {
                curInstance.find('.adult-nos .input-group-bookst--btn .plus').attr('disabled', false);
                curInstance.find('.child-nos .input-group-bookst--btn .plus').attr('disabled', false);
                curInstance.find('.teenager-nos .input-group-bookst--btn .plus').attr('disabled', false);
                // curInstance.find('.infant-nos .input-group-bookst--btn .plus').attr('disabled', false);
            }
        }
    }

    /**
	 * @function initSelectize
	 * @param {any} listItems [description]
	 * !!! Properly scoped
	 */
    initSelectize(listItems: any, instance: any): void {
        let _self = this;
        let curInstance = $(instance).find('.sidetrip-container');
        let bcommon = _self.bcommon;

        let $onewayLocationSideTrip: any = curInstance.find('.sidetrip-to--location');
        let $returnLocationSideTrip: any = curInstance.find('.sidetrip-return-to--location');

        let $onewayLocationSideTripTitle: any = $onewayLocationSideTrip.parent().find('.booking-form--title');
        let $onewayLocationSelectizeInput: any = $onewayLocationSideTrip.parent().find('.selectize-control .selectize-input');

        let $oneWayTripDateById: any = curInstance.find('#onewayTripDateSelectorMob');
        let $returnTripDateById: any = curInstance.find('#returnTripDateSelectorMob');

        $onewayLocationSideTrip.html(listItems);

        $onewayLocationSideTrip.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($onewayLocationSideTrip[0].selectize);
            },
            onFocus: function () {
                $onewayLocationSideTripTitle.addClass('input-filled');
                $onewayLocationSelectizeInput.addClass('select-filled');
                $onewayLocationSelectizeInput.removeClass('has-error');
                $onewayLocationSideTripTitle.removeClass('has-error');
                let $onewayLocationChange = $onewayLocationSideTrip.find('option:selected').text();				
				if($onewayLocationChange !== '') {
					$onewayLocationSideTrip[0].selectize.clear();
				}
            },
            onDropdownOpen: function ($dropdown: any) {
            },
            onChange: function () {
                $onewayLocationSideTripTitle.addClass('input-filled');
                $onewayLocationSelectizeInput.addClass('select-filled');
                let onewayLocationSideTripVal = $onewayLocationSideTrip.val().trim();
                let $onewayLocationChange = $onewayLocationSideTrip.find('option:selected').text();
                if($oneWayTripDateById.find('input[name="sideTripDate"]').val() == '' && $onewayLocationChange != '') {
                    $oneWayTripDateById.find('input[name="sideTripDate"]').focus();
                }
               
            },
            onBlur: function () {
                let $onewayLocationSideTripChange = $onewayLocationSideTrip.find('option:selected').text();
                if ($onewayLocationSideTripChange == '') {
                    $onewayLocationSideTripTitle.removeClass('input-filled');
                    $onewayLocationSelectizeInput.removeClass('select-filled');
                } else {
                    $onewayLocationSideTripTitle.addClass('input-filled');
                    $onewayLocationSelectizeInput.addClass('select-filled');
                }
            },
            searchField: ['text'],
            selectOnTab: true,
            render: {
				item: function(item:any, escape:any) {					
					return '<div>' +
					(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
					'</div>';				
				},
				option: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span></p><p class = "airportline2">' + escape(item.text.split('|')[1]) + '</p>': '') +
					'</div>';
				}
			}
        });

        $(".sidetrip-to--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });

        $returnLocationSideTrip.html(listItems);

        let $returnLocationSideTriptitle: any = $returnLocationSideTrip.parent().find('.booking-form--title');
        let $returnLocationSideTripSelectizeInput: any;

        $returnLocationSideTrip.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($returnLocationSideTrip[0].selectize);
                $returnLocationSideTripSelectizeInput = $returnLocationSideTrip[0].selectize.$control;
            },
            onFocus: function () {
                $returnLocationSideTriptitle.addClass('input-filled');
                $returnLocationSideTripSelectizeInput.addClass('select-filled');
                $returnLocationSideTripSelectizeInput.removeClass('has-error');
                $returnLocationSideTriptitle.removeClass('has-error');
                let $returnLocationChange = $returnLocationSideTrip.find('option:selected').text();				
				if($returnLocationChange !== '') {
					$returnLocationSideTrip[0].selectize.clear();
				}
            },
            onDropdownOpen: function ($dropdown: any) {
            },
            onChange: function (value: any) {
                $returnLocationSideTriptitle.addClass('input-filled');
                $returnLocationSideTripSelectizeInput.addClass('select-filled');
                let $returnLocationChange = $returnLocationSideTrip.find('option:selected').text();
                if($returnTripDateById.find('input[name="sideTripReturnDate"]').val() == '' && $returnLocationChange != '' ) {
                    $returnTripDateById.find('input[name="sideTripReturnDate"]').focus();
                }
                

            },
            onBlur: function () {
                let $returnLocationSideTripChange = $returnLocationSideTrip[0].selectize.$input.val();
                if (!$returnLocationSideTripChange.length) {
                    $returnLocationSideTriptitle.removeClass('input-filled');
                    $returnLocationSideTripSelectizeInput.removeClass('select-filled');
                } else {
                    $returnLocationSideTriptitle.addClass('input-filled');
                    $returnLocationSideTripSelectizeInput.addClass('select-filled');
                }
            },
            onLoad: function (data: any) {
            },
            searchField: ['text'],
            selectOnTab: true,
            render: {
				item: function(item:any, escape:any) {					
					return '<div>' +
					(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
					'</div>';				
				},
				option: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span></p><p class = "airportline2">' + escape(item.text.split('|')[1]) + '</p>': '') +
					'</div>';
				}
			}
        });

    }

    initSelectizeIbeSideTrip(listItems: any, instance: any): void {
        let _self = this;
        let curInstance = $(instance).find('.book--sidetrip-container');
        let bcommon = _self.bcommon;

        let $fromLocationSideTrip: any = curInstance.find('.ibe-sideTrip-from--location');
        let $toLocationSideTrip: any = curInstance.find('.ibe-sideTrip-to--location');
        let $toLocationSideTripById: any = curInstance.find('#ibesideTripToLocation');

        let $fromLocationSideTripTitle: any = $fromLocationSideTrip.parent().find('.booking-form--title');
        let $fromLocationSelectizeInput: any = $fromLocationSideTrip.parent().find('.selectize-control .selectize-input');
        let ukCities: any;
        let $isEnableCNN: any = $('#isEnableCNN');
        if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
            ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
        }
        else {
            ukCities = [];
        }		
        let $returnTripDateSelectorMobById: any = curInstance.find('#returnSideTripDateSelectorMob');
        let $oneWayTripDateSelectorMobById: any = curInstance.find('#oneWaySideTripDateSelectorMob');

        $fromLocationSideTrip.html(listItems);

        $fromLocationSideTrip.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($fromLocationSideTrip[0].selectize);
            },
            onFocus: function () {
                $fromLocationSideTripTitle.addClass('input-filled');
                $fromLocationSelectizeInput.addClass('select-filled');
                $fromLocationSelectizeInput.removeClass('has-error');
                $fromLocationSideTripTitle.removeClass('has-error');
                let $fromLocationChange = $fromLocationSideTrip.find('option:selected').text();               				
				if($fromLocationChange !== '') {
					$fromLocationSideTrip[0].selectize.clear();
				}
            },
            onDropdownOpen: function ($dropdown: any) {
            },
            onChange: function () {
                $fromLocationSideTripTitle.addClass('input-filled');
                $fromLocationSelectizeInput.addClass('select-filled');
                let fromLocationSideTripVal = $fromLocationSideTrip.val().trim();
                if (ukCities.includes(fromLocationSideTripVal) || ukCities.includes($toLocationSideTrip.val())) {
                    $('.passenger-details-selected .fst_teenager-cat').css('display', 'block');
                    $('.passenger-details-selected .is-uk').css('display', 'block');
                    $('.passenger-details-selected .isnt-uk').css('display', 'none');
                    _self.isUkCitySelectedForIbeSearch = true;
                } else {
                    $('.passenger-details-selected .isnt-uk').css('display', 'block');
                    $('.passenger-details-selected .fst_teenager-cat').css('display', 'none');
                    $('.passenger-details-selected .is-uk').css('display', 'none');
                    _self.isUkCitySelectedForIbeSearch = false;
                    curInstance.find('.passenger-details-selected .ticket-mob-teenager--input').val(0).trigger('change');
                }
                bcommon.updateAirportOnDListOnFlowChangeNew("Sidetrip", fromLocationSideTripVal, $toLocationSideTrip);
                if (fromLocationSideTripVal) {
                    setTimeout(function () {
                        $toLocationSideTripById.find('input[type="select-one"]').focus();
                        $toLocationSideTriptitle.addClass('input-filled');
                        $toLocationSideTripSelectizeInput.addClass('select-filled');
                    }, 400);
                }
            },
            onBlur: function () {
                let $fromLocationSideTripChange = $fromLocationSideTrip.find('option:selected').text();
                if ($fromLocationSideTripChange == '') {
                    $fromLocationSideTripTitle.removeClass('input-filled');
                    $fromLocationSelectizeInput.removeClass('select-filled');
                } else {
                    $fromLocationSideTripTitle.addClass('input-filled');
                    $fromLocationSelectizeInput.addClass('select-filled');
                }
            },
            searchField: ['text'],
            selectOnTab: true,
            render: {
				item: function(item:any, escape:any) {
					if (item.text.split('|')[0] === 'Recent') {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[2].split('__')[0]) + ' ('+ escape(item.text.split('|')[1]) +')</span>' : '') +
							'</div>';
					} else {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' ('+ escape(item.text.split('|')[2]) + ')</span>' : '') +
							'</div>';
					}			
				},
				option: function(item:any, escape:any) {
					if (item.text.split('|')[0] === 'Recent') {
						let recentRetdate: string = (item.text.split('|')[8] !== "undefined"||undefined)? ' - ' + escape(item.text.split('|')[8]):'';
						let numberPax: string =  (item.text.split('|')[12] !== "undefined"||undefined)? ', ' + escape(item.text.split('|')[12]) + ' ' + '<i class="fa fa-user" aria-hidden="true"></i>': '';
						return '<div>' +
							(item.text ? '<p><span class = "airportname">' + escape(item.text.split('|')[2].split('__')[0]) +
								'</span> to <span class = "airportname">' + escape(item.text.split('|')[4].split('__')[0]) +
								'</span></p><p><span class = "recentdate">' +
								 escape(item.text.split('|')[6]) + recentRetdate + numberPax + '</span></p>': '') +
							'</div>';
					} else {
						return '<div>' +
							(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +
								'<span class = "airportcode">' +
								escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
							'</div>';
					}
				}
			}
        });

        $("ibe-sideTrip-from--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });

        $toLocationSideTrip.html(listItems);

        let $toLocationSideTriptitle: any = $toLocationSideTrip.parent().find('.booking-form--title');
        let $toLocationSideTripSelectizeInput: any;

        $toLocationSideTrip.selectize({
            onInitialize: function () {
                curInstance.find('.isnt-uk').css('display', 'block');
                curInstance.find('.passenger-details-selected .fst_teenager-cat').css('display', 'none');
                curInstance.find('.passenger-details-selected .is-uk').css('display', 'none');
                _self.wcag.selectizeInputAria($toLocationSideTrip[0].selectize);
                $toLocationSideTripSelectizeInput = $toLocationSideTrip[0].selectize.$control;
            },
            onFocus: function () {
                $toLocationSideTriptitle.addClass('input-filled');
                $toLocationSideTripSelectizeInput.addClass('select-filled');
                $toLocationSideTripSelectizeInput.removeClass('has-error');
                $toLocationSideTriptitle.removeClass('has-error');
                let $toLocationChange = $toLocationSideTrip.find('option:selected').text();               				
				if($toLocationSideTrip !== '') {
					$toLocationSideTrip[0].selectize.clear();
				}
            },
            onDropdownOpen: function ($dropdown: any) {
            },
            onChange: function (value: any) {
                $toLocationSideTriptitle.addClass('input-filled');
                let ibeFromLocationValsideTrip = $fromLocationSideTrip.val().trim();
                $toLocationSideTripSelectizeInput.addClass('select-filled');
                let fromLocationSideTripVal = $fromLocationSideTrip.val().trim();
                if (ukCities.includes(fromLocationSideTripVal) || ukCities.includes($toLocationSideTrip.val())) {
                    $('.passenger-details-selected .fst_teenager-cat').css('display', 'block');
                    $('.passenger-details-selected .is-uk').css('display', 'block');
                    $('.passenger-details-selected .isnt-uk').css('display', 'none');
                    _self.isUkCitySelectedForIbeSearch = true;
                } else {
                    $('.passenger-details-selected .isnt-uk').css('display', 'block');
                    $('.passenger-details-selected .fst_teenager-cat').css('display', 'none');
                    $('.passenger-details-selected .is-uk').css('display', 'none');
                    _self.isUkCitySelectedForIbeSearch = false;
                    curInstance.find('.passenger-details-selected .ticket-mob-teenager--input').val(0).trigger('change');
                }
                // show error if from and to fields are the same and not empty
                if ($fromLocationSideTrip.val() === $toLocationSideTrip.val() && $fromLocationSideTrip.val().length > 0) {
                    $toLocationSideTripSelectizeInput.addClass('has-error');
                    $toLocationSideTriptitle.addClass('has-error');
                }
                else {
                    $toLocationSideTripSelectizeInput.removeClass('has-error');
                    $toLocationSideTriptitle.removeClass('has-error');
                }
                if ($toLocationSideTrip.val().trim() != "") {
                    setTimeout(function () {
                        if (!$('#oneWaySideTripDateSelectorMob').is(':visible')) {
                            if ($('#returnSideTripDateSelectorMob').find('.departureDateSideTrip').val() == '') {
                                $returnTripDateSelectorMobById.find('input[name="ReturnTripStartMobile"]').focus();
                            }
                        } else {
                            if ($('#oneWaySideTripDateSelectorMob').find('.departureDateSideTrip').val() == '') {
                                $oneWayTripDateSelectorMobById.find('input[name="OneWayTripMobile"]').focus();
                            }
                        }
                    }, 200);
                }

            },
            onBlur: function () {
                let $toLocationSideTripChange = $toLocationSideTrip[0].selectize.$input.val();
                if (!$toLocationSideTripChange.length) {
                    $toLocationSideTriptitle.removeClass('input-filled');
                    $toLocationSideTripSelectizeInput.removeClass('select-filled');
                } else {
                    $toLocationSideTriptitle.addClass('input-filled');
                    $toLocationSideTripSelectizeInput.addClass('select-filled');
                }
            },
            onLoad: function (data: any) {
            },
            searchField: ['text'],
            selectOnTab: true,
            render: {
				item: function(item:any, escape:any) {					
					return '<div>' +
					(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
					'</div>';				
				},
				option: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span></p><p>' + escape(item.text.split('|')[1]) + '</p>': '') +
					'</div>';
				}
			}
        });
        let $cabinSelected: any = curInstance.find('.cabin-class-sidetrip');
        $cabinSelected.selectize({
            onInitialize: function () {
                _self.wcag.selectizeInputAria($cabinSelected[0].selectize);
                // set economy as default on load
                $cabinSelected[0].selectize.setValue('CFFECO');
            },
            onFocus: function () {
                $cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
                curInstance.find('.cabin-class-sidetrip.selectize-control.single .selectize-input').addClass('select-filled');
            },
            onChange: function () {
                $cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
                curInstance.find('.cabin-class-sidetrip.selectize-control.single .selectize-input').addClass('select-filled');
            },
            onBlur: function () {
                let $cabinClassChange = $cabinSelected.find('option:selected').text();
                if ($cabinClassChange == '') {
                    $cabinSelected.parent().find('.booking-form--title').removeClass('input-filled');
                    curInstance.find('.cabin-class-sidetrip.selectize-control.single .selectize-input').removeClass('select-filled');
                } else {
                    $cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
                    curInstance.find('.cabin-class-sidetrip.selectize-control.single .selectize-input').addClass('select-filled');
                }
            }
        });

    }
    /**
    * @function ibeTripType
	 * !!! Properly scoped
	 */
    ibeTripType(instance: any): void {

        let curInstance = $(instance).find('.book--sidetrip-container'); // assign current instance to var as later requests will call latest assigned instance

        let returnDate = '';

        // return trip click event (mobile)
        curInstance.find('.trip-type--container .returnsideTrip').click(function () {
            returnTripClickHandler(this, curInstance);
        });

        // one way trip click event (mobile)
        curInstance.find('.trip-type--container .oneWaysideTrip').click(function () {
            oneWayTripClickHandler(this, curInstance);
        });



		/*
		* return trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
        function returnTripClickHandler(el: any, instance: any) {
            let bdsRetTrip: any = instance.find('.book-date--selector.returnsideTrip');
            let bdsOneTrip: any = instance.find('.book-date--selector.oneWaysideTrip');
            let mobReturnTripDepartureDate: any = instance.find('.returnsideTrip .departureDateSideTrip');

            // clear select state on all trip type selectors
            $(el).parent().find('li').removeClass('selected');
            $(el).addClass('selected');

            // toggle display of OnD fields
            bdsRetTrip.show();
            bdsOneTrip.hide();


            if (returnDate != '') {
                bdsRetTrip.find('.returnDateSideTrip').val(returnDate);
            }
        }

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
        function oneWayTripClickHandler(el: any, instance: any) {
            let bdsRetTrip: any = instance.find('.book-date--selector.returnsideTrip');
            let bdsOneTrip: any = instance.find('.book-date--selector.oneWaysideTrip');
            let mobOneWayTripDepartureDate = instance.find('.returnsideTrip .departureDateSideTrip');

            // clear select state on all trip type selectors
            $(el).parent().find('li').removeClass('selected');
            $(el).addClass('selected');

            // toggle display of OnD fields
            bdsRetTrip.hide();
            bdsOneTrip.show();
            returnDate = bdsRetTrip.find('.returnDateSideTrip').val();
            bdsRetTrip.find('.returnDateSideTrip').val('');
        }
    }


    /**
	 * @function calendarComponent
	 * @param  {any} instance [current instance]
	 */
    calendarComponent(instance: any): void {
        let _self = this;
        let bcommon = _self.bcommon;

        let curInstance = $(instance); // assign current instance to var as later requests will call latest assigned instance

        let nowDate: any = new Date();
        let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
        let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
        let maxLimitDate: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + maxDays, 0, 0, 0, 0);

        let $curDatepickerInst: any;
        let $curDatepickerTitle: string;

        let $deviceHeight = $(window).height() / 1.78;

        // function highlightMobileDays(date: any) {
        //     var startDate = new Date(curInstance.find('.departureDateMobile').datepicker('getDate'));
        //     var endDate = new Date(curInstance.find('.returnDateMobile').datepicker('getDate'));

        //     if ((startDate <= date) && (date <= endDate)) {
        //         return [true, 'highlight'];
        //     } else {
        //         return [true, ''];
        //     }
        // }

        function dateDisplayFormat(sideTripStartDate: any, sideTripSelectDate: any) {
            var stdate = moment(sideTripStartDate, 'DD.MM.YYYY');
            var seldate = moment(sideTripSelectDate, 'DD.MM.YYYY');
            var diffdate = seldate.diff(stdate, 'days') + 1;
            return moment(sideTripStartDate).format('DD MMM') + ' - ' + moment(sideTripSelectDate).format('DD MMM') + ' (' + diffdate + ' days)';
        }

        $(function () {
            let $dateFormat: any = 'dd M yy';
            function getDate($element: any) {
                let $getDate: any;
                try {
                    $getDate = $.datepicker.parseDate($dateFormat, $element.value);
                } catch (error) {
                    $getDate = null;
                }
                return $getDate;
            }
        });

        curInstance.find('#sidetrip-select-domestic-location .sideTripDate').datepicker({
            showButtonPanel: true,
            closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
            minDate: today,
            //beforeShowDay: highlightMobileDays,            
            dateFormat: 'dd M yy',
            maxDate: maxLimitDate,
            numberOfMonths: 2,
            firstDay: 1,
            beforeShow: function (ele: any, obj: any) {
                $curDatepickerInst = obj.dpDiv[0];
                $curDatepickerTitle = ele.dataset.datepickerTitle;
                $('#ui-datepicker-div').addClass('sidetrip-calender-align');
            },
            onClose: function(selectedDate: any) {
                setTimeout(function () {
                    $('#ui-datepicker-div').removeClass('sidetrip-calender-align');                   
                }, 300);
            },
            afterShow: function () {
                bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
            }
        })
        .on('change', function () {
            curInstance.find('#sidetrip-oneway-details-expanded .onewaydate-sidetrip').text(curInstance.find('#sidetrip-oneway-details-expanded .onewaydate').text() + ' - ' + $(this).val());
            curInstance.find('#sidetrip-oneway-details-expanded .hubstartdate').text($(this).val());
        });

        curInstance.find('#sidetrip-select-domestic-location-return .sideTripReturnDate').datepicker({
            showButtonPanel: true,
            closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
            minDate: today,
            //beforeShowDay: highlightMobileDays,           
            dateFormat: 'dd M yy',
            maxDate: maxLimitDate,
            numberOfMonths: 2,
            firstDay: 1,
            beforeShow: function (ele: any, obj: any) {
                $curDatepickerInst = obj.dpDiv[0];
                $curDatepickerTitle = ele.dataset.datepickerTitle;
                $('#ui-datepicker-div').addClass('sidetrip-calender-align');
            },
            onClose: function(selectedDate: any) {
                setTimeout(function () {
                    $('#ui-datepicker-div').removeClass('sidetrip-calender-align');                   
                }, 300);
            },
            afterShow: function () {
                bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
            }
        })
        .on('change', function () {
            curInstance.find('#sidetrip-return-details-expanded .returndate-sidetrip').text(curInstance.find('#sidetrip-return-details-expanded .returndate').text() + ' - ' + $(this).val());
            curInstance.find('#sidetrip-return-details-expanded .hubstartdate').text($(this).val());
        });        
    }

    /**
	 * @function calendarComponent
	 * !!! Properly scoped
	 */
    calendarComponentSideTrip(instance: any): void {
        let _self = this;
        let bcommon = _self.bcommon;

        let curInstance = $(instance); // assign current instance to var as later requests will call latest assigned instance

        let nowDate: any = new Date();
        let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
        let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
        let maxLimitDate: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + maxDays, 0, 0, 0, 0);

        let $curDatepickerInst: any;
        let $curDatepickerTitle: string;

        let $deviceHeight = $(window).height() / 1.78;

        function highlightMobileDays(date: any) {
            var startDate = new Date(curInstance.find('.departureDateSideTrip').datepicker('getDate'));
            var endDate = new Date(curInstance.find('.returnDateSideTrip').datepicker('getDate'));

            if ((startDate <= date) && (date <= endDate)) {
                return [true, 'highlight'];
            } else {
                return [true, ''];
            }
        }

        $(function () {
            let $dateFormat: any = 'dd M yy',
                $departDate = curInstance.find('.returnsideTrip .departureDateSideTrip')
                    .datepicker({
                        showButtonPanel: true,
                        closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                        minDate: today,
                        beforeShowDay: highlightMobileDays,
                        dateFormat: 'dd M yy',
                        maxDate: maxLimitDate,
                        numberOfMonths: 2,
                        firstDay: 1,
                        beforeShow: function (ele: any, obj: any) {
                            $curDatepickerInst = obj.dpDiv[0];
                            $curDatepickerTitle = ele.dataset.datepickerTitle;
                            $('#ui-datepicker-div').addClass('sidetrip-calender-align');
                        },
                        onClose: function(selectedDate: any) {
                            setTimeout(function () {
                                $('#ui-datepicker-div').removeClass('sidetrip-calender-align');                   
                            }, 60);
                        },
                        afterShow: function () {
                            bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
                        }
                    })

                    .on('change', function () {
                        $returnDate.datepicker('option', 'minDate', getDate(this));
                        window.setTimeout($.proxy(function () {
                            $(this).next('.returnDateSideTrip').focus();
                        }, this), 100);
                    }),

                $returnDate = curInstance.find('.returnDateSideTrip').datepicker({
                    showButtonPanel: true,
                    closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
                    dateFormat: 'dd M yy',
                    minDate: today,
                    maxDate: maxLimitDate,
                    beforeShowDay: highlightMobileDays,
                    numberOfMonths: 2,
                    firstDay: 1,
                    beforeShow: function (ele: any, obj: any) {
                        $curDatepickerInst = obj.dpDiv[0];
                        $curDatepickerTitle = ele.dataset.datepickerTitle;
                        $('#ui-datepicker-div').addClass('sidetrip-calender-align');
                    },
                    onClose: function(selectedDate: any) {
                        setTimeout(function () {
                            $('#ui-datepicker-div').removeClass('sidetrip-calender-align');                   
                        }, 300);
                    },
                    afterShow: function () {
                        bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
                    }
                })

                    .on('change', function () {
                        //	$departDate.datepicker('option', 'maxDate', getDate(this));
                    });

            function getDate($element: any) {
                let $getDate: any;
                try {
                    $getDate = $.datepicker.parseDate($dateFormat, $element.value);
                } catch (error) {
                    $getDate = null;
                }
                return $getDate;
            }
        });

        curInstance.find('.departureDateSideTrip.oneway-trip').datepicker({
            showButtonPanel: true,
            closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
            minDate: today,
            dateFormat: 'd M yy',
            beforeShowDay: highlightMobileDays,
            maxDate: maxLimitDate,
            numberOfMonths: 2,
            firstDay: 1,
            beforeShow: function (ele: any, obj: any) {
                $curDatepickerInst = obj.dpDiv[0];
                $curDatepickerTitle = ele.dataset.datepickerTitle;
                $('#ui-datepicker-div').addClass('sidetrip-calender-align');
            },
            onClose: function(selectedDate: any) {
                setTimeout(function () {
                    $('#ui-datepicker-div').removeClass('sidetrip-calender-align');                   
                }, 300);
            },
            afterShow: function () {
                bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
            }
        });
    }

    sidetripLocationSubmit(instance: any): void {
        let _self = this;
        let curInstance = $(instance).find('#sidetrip-oneway-details-expanded');
        let curInstanceReturn = $(instance).find('#sidetrip-return-details-expanded');
        let sidetripContinue = $(instance).find('.sidetrip-continue');
        curInstance.off('click', '.sidetrip-form-submit').on('click', '.sidetrip-form-submit', (evt: any) => {
            evt.preventDefault();
            let formDataValid = true;
            let $errorList: Array<any> = [];
            let $errorValidation = curInstance.find('.error-validation').first();
            // let $passengerDetails: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details]');
            // let $passengerDetailsActive: any = curInstance.find('[data-sidetrip-oneway-booking-passenger-details-selected]');

            $errorValidation.show();

            // Validation: empty oneway location
            let $sidetripOneWayLocation: any = curInstance.find('.sidetrip-to--location');
            if ($sidetripOneWayLocation.val() == '') {
                $sidetripOneWayLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
                $sidetripOneWayLocation.parent().find('.booking-form--title').addClass('has-error');
                let $sidetripOneWayLocValidate: any = $sidetripOneWayLocation.attr('data-sidetriponewayloc');
                $errorList.push('<strong>' + $sidetripOneWayLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $sidetripOneWayLocValidate);
                formDataValid = false;
            } else {
                $sidetripOneWayLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                $sidetripOneWayLocation.parent().find('.booking-form--title').removeClass('has-error');
            }

            let $oneWayDate: any = curInstance.find('.sideTripDate');
            if ($oneWayDate.val() == '') {
                $oneWayDate.parent().parent().addClass('has-error');
                let $travelDateOne: any = curInstance.find('.sideTripDate').attr('data-mobiletraveldateOne');
                $errorList.push('<strong>' + $oneWayDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
                formDataValid = false;
            } else {
                $oneWayDate.parent().parent().removeClass('has-error');
            }

            // // Validation: no passengers selected
            // if (curInstance.find('input.total-tickets-oneway--value').val() == 0) {
            //     let $nopassenger: any = curInstance.find('.total-tickets-oneway--value.mobile').attr('data-mob-passenger');
            //     $passengerDetails.addClass('has-errors');
            //     $errorList.push('<strong>' + $sidetripOneWayLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $nopassenger);
            //     formDataValid = false;
            // } else {
            //     $passengerDetails.removeClass('has-errors');
            // }


            // if (curInstance.find('.infant-booking--error---sidetrip').css('display') == 'block') {
            //     $passengerDetails.addClass('has-error');
            //     let $moreInfant: any = curInstance.find('.infant-booking--error---sidetrip').attr('data-mobilemoreinfant');
            //     $errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + '</strong>: ' + $moreInfant);
            //     formDataValid = false;
            // } else if (curInstance.find('.adult-booking--error---sidetrip').css('display') == 'block') {
            //     $passengerDetails.addClass('has-error');
            //     let $lessAdult: any = curInstance.find('.adult-booking--error---sidetrip').attr('data-mobilelessadult');
            //     $errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $lessAdult);
            //     formDataValid = false;
            // } else {
            //     $passengerDetails.removeClass('has-error');
            // }


            let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            let $validationMessagelist: any = $validationContainer;

            for (var i = 0, len = $errorList.length; i < len; i++) {
                $validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
            }

            if (formDataValid) {
                $errorValidation.hide();
                curInstance.find('.visitloc').text($sidetripOneWayLocation.val());
                curInstance.find('.onewaydate-sidetrip').text(curInstance.find('.onewaydate').text() + ' - ' + curInstance.find('.sideTripDate').val());
                curInstance.find('#sidetrip-select-domestic-location').collapse('hide');
                $('.sidetrip-oneway-remove-btn').show();
                $('.container--side-trip .sidetrip-to').css({ 'pointer-events': 'none' });
                $('.sidetrip-return-remove-btn').trigger('click');
                $('.sidetrip-form-continue').attr('disabled', false);
            }
            else {
                $('.sidetrip-form-continue').attr('disabled', true);
                $('.sidetrip-oneway-remove-btn').hide();
                $('.container--side-trip .sidetrip-to').css({ 'pointer-events': 'auto' });
            }

        });
        curInstanceReturn.off('click', '.sidetrip-form-submit').on('click', '.sidetrip-form-submit', (evt: any) => {
            evt.preventDefault();
            let formDataValid = true;
            let $errorList: Array<any> = [];
            let $errorValidation = curInstanceReturn.find('.error-validation').first();
            // let $passengerDetails: any = curInstanceReturn.find('[data-sidetrip-return-booking-passenger-details]');
            // let $passengerDetailsActive: any = curInstanceReturn.find('[data-sidetrip-return-booking-passenger-details-selected]');

            $errorValidation.show();

            // Validation: empty return location
            let $sidetripReturnLocation: any = curInstanceReturn.find('.sidetrip-return-to--location');
            if ($sidetripReturnLocation.val() == '') {
                $sidetripReturnLocation.parent().find('.selectize-control .selectize-input').addClass('has-error');
                $sidetripReturnLocation.parent().find('.booking-form--title').addClass('has-error');
                let $sidetripReturnLocValidate: any = $sidetripReturnLocation.attr('data-sidetripreturnloc');
                $errorList.push('<strong>' + $sidetripReturnLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $sidetripReturnLocValidate);
                formDataValid = false;
            } else {
                $sidetripReturnLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                $sidetripReturnLocation.parent().find('.booking-form--title').removeClass('has-error');
            }

            let $ReturnDate: any = curInstanceReturn.find('.sideTripReturnDate');
            if ($ReturnDate.val() == '') {
                $ReturnDate.parent().parent().addClass('has-error');
                let $travelDateOne: any = curInstanceReturn.find('.sideTripReturnDate').attr('data-mobiletraveldateOne');
                $errorList.push('<strong>' + $ReturnDate.parent().find('label.one-dep-title').text() + ':</strong> ' + $travelDateOne);
                formDataValid = false;
            } else {
                $ReturnDate.parent().parent().removeClass('has-error');
            }

            // // Validation: no passengers selected
            // if (curInstanceReturn.find('input.total-tickets-return--value').val() == 0) {
            //     let $nopassenger: any = curInstanceReturn.find('.total-tickets-return--value.mobile').attr('data-mob-passenger');
            //     $passengerDetails.addClass('has-errors');
            //     $errorList.push('<strong>' + $sidetripReturnLocation.parent().find('.booking-form--title').text() + '</strong>: ' + $nopassenger);
            //     formDataValid = false;
            // } else {
            //     $passengerDetails.removeClass('has-errors');
            // }


            // if (curInstanceReturn.find('.infant-booking--error---sidetrip').css('display') == 'block') {
            //     $passengerDetails.addClass('has-error');
            //     let $moreInfant: any = curInstanceReturn.find('.infant-booking--error---sidetrip').attr('data-mobilemoreinfant');
            //     $errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.adult-cat .booking-category').text() + '</strong>: ' + $moreInfant);
            //     formDataValid = false;
            // } else if (curInstanceReturn.find('.adult-booking--error---sidetrip').css('display') == 'block') {
            //     $passengerDetails.addClass('has-error');
            //     let $lessAdult: any = curInstanceReturn.find('.adult-booking--error---sidetrip').attr('data-mobilelessadult');
            //     $errorList.push('<strong>' + $passengerDetails.find('.title-caption').text() + ' - ' + $passengerDetailsActive.find('.infant-cat .booking-category').text() + +'</strong>: ' + $lessAdult);
            //     formDataValid = false;
            // } else {
            //     $passengerDetails.removeClass('has-error');
            // }


            let $validationContainer: any = $errorValidation.find(".mobile-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
            let $validationMessagelist: any = $validationContainer;

            for (var i = 0, len = $errorList.length; i < len; i++) {
                $validationMessagelist.append('<li data-id="' + i + '">' + $errorList[i] + '</li>');
            }

            if (formDataValid) {
                $errorValidation.hide();
                curInstanceReturn.find('.visitloc').text($sidetripReturnLocation.val());
                curInstanceReturn.find('.returndate-sidetrip').text(curInstanceReturn.find('.returndate').text() + ' - ' + curInstanceReturn.find('.sideTripReturnDate').val());
                curInstanceReturn.find('#sidetrip-select-domestic-location-return').collapse('hide');
                $('.sidetrip-return-remove-btn').show();
                $('.container--side-trip .sidetrip-from').css({ 'pointer-events': 'none' });
                $('.sidetrip-oneway-remove-btn').trigger('click');
                $('.sidetrip-form-continue').attr('disabled', false);
            } else {
                $('.sidetrip-form-continue').attr('disabled', true);
                $('.sidetrip-return-remove-btn').hide();
                $('.container--side-trip .sidetrip-from').css({ 'pointer-events': 'auto' });
            }

        });
        sidetripContinue.off('click', '.sidetrip-form-continue').on('click', '.sidetrip-form-continue', (evt: any) => {
            evt.preventDefault();
            let officeId: any;
        if(window.innerWidth>768)
        {
            if ($('.ibe-sidetrip-submit').is(':visible')) {
                let $selected_text = $('.ibe-from--location').find(":selected").text();
                if ($selected_text.includes('|')) {
                    if ($selected_text.split('|')[0] === 'Recent') {
                        officeId = $selected_text.split('|')[9].replace(/\s+/g, "");
                    } else {
                        officeId = $selected_text.split('|')[1].replace(/\s+/g, "");
                    }
                } else {
                    officeId = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
                }
            } else {
                let $selected_text = $('.ibe-sideTrip-from--location').find(":selected").text();
                if ($selected_text.includes('|')) {
                    if ($selected_text.split('|')[0] === 'Recent') {
                        officeId = $selected_text.split('|')[9].replace(/\s+/g, "");
                    } else {
                        officeId = $selected_text.split('|')[1].replace(/\s+/g, "");
                    }
                } else {
                    officeId = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
                }
            }             
        }
        else
        {
            if ($(instance).find('.mobile-sidetrip-submit').is(':visible')) {
                let $selected_text = $(instance).find('.ibe-mob-from--location').find(":selected").text();
                if ($selected_text.includes('|')) {
                    if ($selected_text.split('|')[0] === 'Recent') {
                        officeId = $selected_text.split('|')[9].replace(/\s+/g, "");
                    } else {
                        officeId = $selected_text.split('|')[1].replace(/\s+/g, "");
                    }
                } else {
                    officeId = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
                }
            } else {
                let $selected_text = $(instance).find('.ibe-sideTrip-from--location').find(":selected").text();
                if ($selected_text.includes('|')) {
                    if ($selected_text.split('|')[0] === 'Recent') {
                        officeId = $selected_text.split('|')[9].replace(/\s+/g, "");
                    } else {
                        officeId = $selected_text.split('|')[1].replace(/\s+/g, "");
                    }
                } else {
                    officeId = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
                }
            }    
        }
            let formObj:any = _self.multiBookingFormObject(curInstance);
            _self.bookingFormSubmit.mobileSidetripflowSubmit($(instance).find('.book--sidetrip-container'),formObj,officeId);
        });

    }
    multiBookingFormObject($instance:any): any {
		let _self = this;

		// parse form data
        let formData:any;
         if(window.innerWidth>768)
        {
            if ($('.ibe-sidetrip-submit').is(':visible')) { 
                formData = $('[data-form-booking--trip]').serializeArray();
            }else{
                formData = $('[data-form-sidetrip]').serializeArray();
            }
        }
        else{
            if ($('.mobile-sidetrip-submit').is(':visible')) { 
                formData = $('[data-form-booking--trip]').serializeArray();
            }else{
                formData = $('[data-form-sidetrip]').serializeArray();
            }
        }
		let formObj:any = {};

		$(formData).each(function(i:any, field:any){
			formObj[field.name] = field.value;
		});

		return formObj;
    }
    desktopsidetip(instance: any):void
    {
        
            let _self = this;
            let curInstance = $(instance);
            curInstance.off('click', '.ibe-sidetrip-submit').on('click', '.ibe-sidetrip-submit', (evt: any) => {
            evt.preventDefault();
            let ieversion = new headerContent();
            ieversion.checkIEVersion_disablePupup();
            $('.container--main-header').hide();
            curInstance.find('.container--side-trip').show();
            let nextoneWayDay: any;
            let returnDay: any;
            let onewayTripdate: any = curInstance.find('#sidetrip-oneway-details-expanded .book-date--selector.oneWayTrip');
            let returnTripdate: any = curInstance.find('#sidetrip-return-details-expanded .book-date--selector.oneWayTrip');
            $('.sidetrip-form-continue').attr('disabled', true);
            $('.container--side-trip .oneway-origin').text(curInstance.find('.ibe-from--location').val().trim().split('_')[0]);
            $('.container--side-trip .oneway-destination').text(curInstance.find('.ibe-to--location').val().trim());
            $('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').val('');
            $('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').val('');
            onewayTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            returnTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected')) {
                nextoneWayDay  = new Date(curInstance.find('.returnTrip .departureDate').val().trim());
                returnDay = new Date(curInstance.find('.returnDate').val().trim());               
                $('.container--side-trip .return-origin').text(curInstance.find('.ibe-to--location').val().trim());
                $('.container--side-trip .return-destination').text(curInstance.find('.ibe-from--location').val().trim().split('_')[0]);
                $('.container--side-trip .onewaydate').text(curInstance.find('.returnTrip .departureDate').val().trim());
                $('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.returnTrip .departureDate').val().trim());
                $('.container--side-trip .returndate').text(curInstance.find('.returnDate').val().trim());
                $('.container--side-trip .returndate-sidetrip').text(curInstance.find('.returnDate').val().trim());
                $('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
                $('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
                $('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').datepicker("option", "minDate", returnDay);
            } else {
                nextoneWayDay = new Date(curInstance.find('.departureDate.oneWay-trip').val().trim());
                $('#sidetrip-return-details-expanded').collapse('hide');
                $('.container--side-trip .sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');               
                $('.container--side-trip .onewaydate').text(curInstance.find('.departureDate.oneWay-trip').val().trim());
                $('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.departureDate.oneWay-trip').val().trim()); 
                $(".ibe-freesidetrip_popup").css("width", "35%");
                let userAgent:any = navigator.userAgent || navigator.vendor;
                if( userAgent.match( /iPad/i ))
                {
                $(".ibe-freesidetrip_popup").css("width", "61%");
                }
                $(".sidetrip-container .col-lg-5").attr("style", "display:contents")                            
            }  
        if(window.innerWidth > 767)
        {

        $.magnificPopup.open({
                items: {
                src: '#ibe_sidetrip'
                },
                type: 'inline',
                fixedContentPos:'true',
                midClick: false,
                enableEscapeKey: false,
                alignTop : true,
                overflowY:'scroll'
        });   
        }
		});
    }
    optforsidetripoffer(instance: any, officeCode: any): void {
        let _self = this;
        let curInstance = $(instance);
        let $closesidetripIbe: any = $('.close-sidetrip');
        let $closebooksidetripIbe: any = $('.close-book-sidetrip');
        let $getTripType: any = curInstance.find('.trip-type--container');
        let $closesidetripIbe_desk:any   = $('.close-sidetrip_ibe');
        let $closebooksidetripIbe_desk: any =  $('.close-book-sidetrip_ibe'); 
        curInstance.off('click', '.mobile-sidetrip-submit').on('click', '.mobile-sidetrip-submit', (evt: any) => {
            evt.preventDefault();
            $('.container--main-header').hide();
            curInstance.find('.container--side-trip').show();
            $('body').css({
                			'position': 'fixed'                			
                		});
            let nextoneWayDay: any;
            let returnDay: any;
            let onewayTripdate: any = curInstance.find('#sidetrip-oneway-details-expanded .book-date--selector.oneWayTrip');
            let returnTripdate: any = curInstance.find('#sidetrip-return-details-expanded .book-date--selector.oneWayTrip');
            $('.sidetrip-form-continue').attr('disabled', true);
            curInstance.find('.container--side-trip .oneway-origin').text(curInstance.find('.ibe-mob-from--location').val().trim().split('_')[0]);
            curInstance.find('.container--side-trip .oneway-destination').text(curInstance.find('.ibe-mob-to--location').val().trim());
            curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').val('');
            curInstance.find('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').val('');
            onewayTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            returnTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected')) {
                nextoneWayDay  = new Date(curInstance.find('.returnTrip .departureDateMobile').val().trim());
                returnDay = new Date(curInstance.find('.returnDateMobile').val().trim());               
                curInstance.find('.container--side-trip .return-origin').text(curInstance.find('.ibe-mob-to--location').val().trim());
                curInstance.find('.container--side-trip .return-destination').text(curInstance.find('.ibe-mob-from--location').val().trim().split('_')[0]);
                curInstance.find('.container--side-trip .onewaydate').text(curInstance.find('.returnTrip .departureDateMobile').val().trim());
                curInstance.find('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.returnTrip .departureDateMobile').val().trim());
                curInstance.find('.container--side-trip .returndate').text(curInstance.find('.returnDateMobile').val().trim());
                curInstance.find('.container--side-trip .returndate-sidetrip').text(curInstance.find('.returnDateMobile').val().trim());
                curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
                curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
                curInstance.find('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').datepicker("option", "minDate", returnDay);
            } else {
                nextoneWayDay = new Date(curInstance.find('.departureDateMobile.oneway-trip').val().trim());
                curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
                curInstance.find('.container--side-trip .sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');               
                curInstance.find('.container--side-trip .onewaydate').text(curInstance.find('.departureDateMobile.oneway-trip').val().trim());
                curInstance.find('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.departureDateMobile.oneway-trip').val().trim());                             
            }  
        });
        $closebooksidetripIbe_desk.on('click', (e:any) => {            
            $.magnificPopup.close();
            $('.ibe_freesidetrip').hide();
             $('.trip-type--container .returnTrip').trigger('click');
        });
        $closesidetripIbe_desk.on('click', (e:any) => {    
            $('body').css({
				'position': ''                			
			});        
            $.magnificPopup.close();
            curInstance.find('#sidetrip-oneway-details-expanded').collapse('hide');
            curInstance.find('.container--side-trip .sidetrip-from').css('background', '#61666E 0% 0% no-repeat padding-box');
            curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
            curInstance.find('.container--side-trip .sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
            $('.sidetrip-oneway-remove-btn').trigger('click');
            $('.sidetrip-return-remove-btn').trigger('click');
            $(".ibe-freesidetrip_popup").css("width", "61%");
            $(".sidetrip-container .col-lg-5").attr("style", "display:auto")  
            $('.ibe_freesidetrip').hide();
            $('.trip-type--container .returnTrip').trigger('click');
        });
        $closesidetripIbe.on('click', (e: any) => {
            curInstance.find('.container--side-trip').hide();
            curInstance.find('.sidetrip-eligibility-error').hide();
            curInstance.find('.container--book-sidetrip').hide();
            $('body').css({
				'position': ''                			
			});
            curInstance.find('.sidetrippanel').hide();
			curInstance.find('.mobile-search-form-submit').show();
            curInstance.find('#sidetrip-oneway-details-expanded').collapse('hide');
            curInstance.find('.container--side-trip .sidetrip-from').css('background', '#61666E 0% 0% no-repeat padding-box');
            curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
            curInstance.find('.container--side-trip .sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
            $('.sidetrip-oneway-remove-btn').trigger('click');
            $('.sidetrip-return-remove-btn').trigger('click');
            // $getTripType.find('.sideTrip').trigger('click');
            $getTripType.find('.returnTrip').trigger('click');
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $('html,body').animate({
                    'scrollTop': 0
                });
            }
        });
        $closebooksidetripIbe.on('click', (e: any) => {
            curInstance.find('.container--book-sidetrip').hide();
            curInstance.find('.sidetrip-eligibility-error').hide();
            $('body').css({
				'position': ''                			
			});
            curInstance.find('.sidetrippanel').hide();
			curInstance.find('.mobile-search-form-submit').show();
            $('.container--main-header').show();
            $getTripType.find('.returnTrip').trigger('click');
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $('html,body').animate({
                    'scrollTop': 0
                });
            }
        });

        curInstance.find('.sidetrip-oneway-details').on('click', function () {
            if ($(this).attr("role") === "button") {
                if ($(this).hasClass('collapsed')) {
                    curInstance.find('.sidetrip-from').css('background', 'transparent linear-gradient(90deg, #25367B 0%, #007AC4 100%) 0% 0% no-repeat padding-box');
                } else {
                    curInstance.find('.sidetrip-from').css('background', '#61666E 0% 0% no-repeat padding-box');
                }
                curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
                if (curInstance.find('.sidetrip-return-details').hasClass('collapsed')) {                    
                    curInstance.find('.sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
                } else {
                    curInstance.find('.sidetrip-to').css('background', 'transparent linear-gradient(90deg, #25367B 0%, #60348D 100%) 0% 0% no-repeat padding-box');
                }
            }
        });

        curInstance.find('.sidetrip-return-details').on('click', function () {
            if ($(this).attr("role") === "button") {
                if ($(this).hasClass('collapsed')) {
                    curInstance.find('.sidetrip-to').css('background', 'transparent linear-gradient(90deg, #25367B 0%, #60348D 100%) 0% 0% no-repeat padding-box');
                } else {
                    curInstance.find('.sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
                }
                curInstance.find('#sidetrip-oneway-details-expanded').collapse('hide');
                if (curInstance.find('.sidetrip-oneway-details').hasClass('collapsed')) {
                    curInstance.find('.sidetrip-from').css('background', '#61666E 0% 0% no-repeat padding-box');                    
                } else {
                    curInstance.find('.sidetrip-from').css('background', 'transparent linear-gradient(90deg, #25367B 0%, #007AC4 100%) 0% 0% no-repeat padding-box');                    
                }
            }
        });

        curInstance.find('.sidetrip-oneway-remove-btn').on('click', function () {
            let $onewayLocationSideTripTitle: any = curInstance.find('.sidetrip-to--location').parent().find('.booking-form--title');
            let $onewayLocationSelectizeInput: any = curInstance.find('.sidetrip-to--location').parent().find('.selectize-control .selectize-input');
            let onewayTripdate: any = curInstance.find('#sidetrip-oneway-details-expanded .book-date--selector.oneWayTrip');
            curInstance.find('#sidetrip-oneway-details-expanded').collapse('hide');
            curInstance.find('#sidetrip-oneway-details-expanded .visitloc').text('Visit Malaysia');
            curInstance.find('#sidetrip-oneway-details-expanded .hubstartdate').text('');
            curInstance.find('.onewaydate-sidetrip').text(curInstance.find('#sidetrip-oneway-details-expanded .onewaydate').text());
            $(this).hide();
            curInstance.find('.sidetrip-from').css('background', '#61666E 0% 0% no-repeat padding-box');
            if(window.innerWidth>768){
               $('select.sidetrip-to--location')[0].selectize.clear();
            }
            else{
            curInstance.find('select.sidetrip-to--location')[0].selectize.clear();
            }    
            $onewayLocationSideTripTitle.removeClass('input-filled');
            $onewayLocationSelectizeInput.removeClass('select-filled');
            curInstance.find('.sideTripDate').val('');
            onewayTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            $('.container--side-trip .sidetrip-to').css({ 'pointer-events': 'auto' });
            $('.sidetrip-form-continue').attr('disabled', true);
        });

        curInstance.find('.sidetrip-return-remove-btn').on('click', function () {
            let $returnLocationSideTripTitle: any = curInstance.find('.sidetrip-return-to--location').parent().find('.booking-form--title');
            let $returnLocationSelectizeInput: any = curInstance.find('.sidetrip-return-to--location').parent().find('.selectize-control .selectize-input');
            let returnTripdate: any = curInstance.find('#sidetrip-return-details-expanded .book-date--selector.oneWayTrip');
            curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
            curInstance.find('#sidetrip-return-details-expanded .visitloc').text('Visit Malaysia');
            curInstance.find('#sidetrip-return-details-expanded .hubstartdate').text('');
            curInstance.find('.returndate-sidetrip').text(curInstance.find('#sidetrip-return-details-expanded .returndate').text());
            $(this).hide();
            curInstance.find('.sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
             if(window.innerWidth>768){
                $('select.sidetrip-return-to--location')[0].selectize.clear();
            }
            else{
                curInstance.find('select.sidetrip-return-to--location')[0].selectize.clear();
            }  
           
            $returnLocationSideTripTitle.removeClass('input-filled');
            $returnLocationSelectizeInput.removeClass('select-filled');
            curInstance.find('.sideTripReturnDate').val('');
            returnTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
            $('.container--side-trip .sidetrip-from').css({ 'pointer-events': 'auto' });
            $('.sidetrip-form-continue').attr('disabled', true);
        });

   curInstance.off('click', '.mobile-sidetrip-form-next').on('click', '.mobile-sidetrip-form-next', (evt: any) => {
            evt.preventDefault();
            let del = _self.getOfficeCode(curInstance);
            let nextoneWayDay: any;
            let returnDay: any;
            let onewayTripdate: any = curInstance.find('#sidetrip-oneway-details-expanded .book-date--selector.oneWayTrip');
            let returnTripdate: any = curInstance.find('#sidetrip-return-details-expanded .book-date--selector.oneWayTrip');
            _self.bookingFormSubmit.sidetripBookingFormValidation(curInstance.find('.book--sidetrip-container'), _self.$officeCode, function ($officeCode: any) {
                if (_self.bookingFormSubmit.mobileSidetripPanelEligibilityCheck(curInstance)) {
                    curInstance.find('.sidetrip-eligibility-error').hide();
                    $('.container--main-header').hide();
                    $('.sidetrip-form-continue').attr('disabled', true);
                    curInstance.find('.container--side-trip .oneway-origin').text(curInstance.find('.ibe-sideTrip-from--location').val().trim().split('_')[0]);
                    curInstance.find('.container--side-trip .oneway-destination').text(curInstance.find('.ibe-sideTrip-to--location').val().trim());
                    curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').val('');
                    curInstance.find('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').val('');
                    onewayTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
                    returnTripdate.find('.dep-return--title .one-dep-title').removeClass('input-filled');
                    if (curInstance.find('.trip-type--container .returnsideTrip').hasClass('selected')) {
                        nextoneWayDay = new Date(curInstance.find('.returnsideTrip .departureDateSideTrip').val().trim());
                        returnDay = new Date(curInstance.find('.returnDateSideTrip').val().trim());
                        curInstance.find('.container--side-trip .return-origin').text(curInstance.find('.ibe-sideTrip-to--location').val().trim());
                        curInstance.find('.container--side-trip .return-destination').text(curInstance.find('.ibe-sideTrip-from--location').val().trim().split('_')[0]);
                        curInstance.find('.container--side-trip .onewaydate').text(curInstance.find('.returnsideTrip .departureDateSideTrip').val().trim());
                        curInstance.find('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.returnsideTrip .departureDateSideTrip').val().trim());
                        curInstance.find('.container--side-trip .returndate').text(curInstance.find('.returnDateSideTrip').val().trim());
                        curInstance.find('.container--side-trip .returndate-sidetrip').text(curInstance.find('.returnDateSideTrip').val().trim());
                        curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
                        curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "maxDate", returnDay);
                        curInstance.find('.container--side-trip #sidetrip-select-domestic-location-return .sideTripReturnDate').datepicker("option", "minDate", returnDay);
                    } else {
                        nextoneWayDay = new Date(curInstance.find('.departureDateSideTrip.oneway-trip').val().trim());
                        curInstance.find('#sidetrip-return-details-expanded').collapse('hide');
						if(window.innerWidth > 767)
                        {  
                            $(".ibe-freesidetrip_popup").css("width", "35%");
                            $(".sidetrip-container .col-lg-5").attr("style", "display:contents") 
                            let userAgent:any = navigator.userAgent || navigator.vendor;
                            if( userAgent.match( /iPad/i ))
                            {
                                 $(".ibe-freesidetrip_popup").css("width", "61%");
                            }
                        }
                        curInstance.find('.container--side-trip .sidetrip-to').css('background', '#61666E 0% 0% no-repeat padding-box');
                        curInstance.find('.container--side-trip .onewaydate').text(curInstance.find('.departureDateSideTrip.oneway-trip').val().trim());
                        curInstance.find('.container--side-trip .onewaydate-sidetrip').text(curInstance.find('.departureDateSideTrip.oneway-trip').val().trim());
                        curInstance.find('.container--side-trip #sidetrip-select-domestic-location .sideTripDate').datepicker("option", "minDate", nextoneWayDay);
                    }
                    curInstance.find('.container--side-trip').show();
					if(window.innerWidth > 767)
                    {  
                        $('.container--main-header').show();           
                        $.magnificPopup.open({
                        items: {
                            src: '#ibe_sidetrip'
                        },
                        type: 'inline',
                        fixedContentPos:'true',
                        midClick: false,
                        alignTop : true,
                        enableEscapeKey: false,
                        overflowY:'scroll'
                    });   
                    } 
                    $('body').css({
                        'position': 'fixed'
                    });
                } else {
                    curInstance.find('.sidetrip-eligibility-error').show();
                    curInstance.find('.sidetrip-eligibility-error').html('Something went wrong. Please try after sometime.')
                }

            });
        });

    }

    /**
	 * @function getOfficeCode
	 * !!! Properly scoped
	 */
    getOfficeCode(instance: any): void {
        let curInstance = $(instance).find('.book--sidetrip-container');
        let _self = this;

        let setOfficeID = function ($fromOfficeID: any) {
            _self.$officeCode = $fromOfficeID;
        };

        curInstance.find('.ibe-sideTrip-from--location').change(function (e: any) {
            let $pickerID = e.target.id;
            let $selected = $(this).find(":selected");
            // let $selected_val = $selected.val();
            let $selected_text = $selected.text();
            let $fromOfficeID: any;
            // let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
            if ($selected_text.includes('|')) {
                if ($selected_text.split('|')[0] === 'Recent') {
                    $fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
                } else {
                    $fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
                }
            } else {
                $fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
            }
            setOfficeID($fromOfficeID);
        });
    }
}